export const updateLoginData = (data, dispatch) => {
  /** SE il classifier è PERSON o è presente TaxRegion === "IT" il vecchio id è codice fiscale, altrimenti è uuid */
  const oldId = data.item.classifier !== "PERSON" && data?.item?.taxRegion === "IT" ? data.item.taxId : data.item.id;

  let authData = {
    loginAuth: {
      securityToken: data.user.token,
      id: data.user.id
    }
  };

  dispatch({
    type: "UPDATE_LOGIN_DATA_AUTH",
    payload: authData
  });
  let mainData =
    data.item.classifier !== "STUDIO"
      ? {
        companySelected: data.item.taxId,
        clientIdSelected: oldId,
        companyUuidSelected: data.item.id,
        myType: data.item.classifier
      }
      : {
        accountantSelected: oldId,
        accountantIdSelected: oldId,
        accountantUuidSelected: data.item.id,
        myType: data.item.classifier
      };
  dispatch({
    type: "UPDATE_LOGIN_DATA_MAIN",
    payload: mainData
  });
  localStorage.setItem(data.item.classifier !== "STUDIO" ? "selectedClient" : "selectedAccountant", data.item.taxId);
  localStorage.setItem(data.item.classifier !== "STUDIO" ? "selectedClientID" : "selectedAccountantID", oldId);
  localStorage.setItem(data.item.classifier !== "STUDIO" ? "selectedClientUUID" : "selectedAccountantUUID", data.item.id);
  if (data.item.classifier === "STUDIO") {
    localStorage.setItem("selectedStudio", oldId);
  }

  return true;
};
